import { QueryClient } from 'react-query';

export function criaQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // O padrão do react-query é retry: 3 com backoff de 1s, 2s e 4s: sete
        // segundos de spinner antes de a tela admitir que falhou. E o retryer
        // pausa a espera enquanto document.visibilityState não é 'visible', então
        // trocar de aba no meio do caminho congela a query em "loading" até o
        // usuário voltar.
        //
        // A API é local, então tentar de novo automaticamente rende pouco: é
        // melhor falhar na hora e mostrar o erro, com um botão de "Tentar
        // novamente" para quem quiser insistir.
        retry: 0,

        // Os cadastros que estas telas mostram — Conta, Moeda, Agência, Centro de
        // Custo, Plano de Contas — são editados no IFLEX, em outra aba. Voltar
        // para cá tem que mostrar o que acabou de ser gravado lá, e sem 'always'
        // o react-query respeitaria o staleTime e serviria o cache: em quase toda
        // lista isso são cinco minutos de dado velho, que só o F5 corrigia.
        //
        // Só dispara quando a janela recupera o foco, que é exatamente a volta do
        // IFLEX — navegar dentro do OktonBank continua servindo o cache.
        refetchOnWindowFocus: 'always',
      },
    },
  });
}
